import Cafe from "./custom/cafe.js"
import Trout from "./custom/trout.js"
import Home from "./custom/home.js"
import Camping from "./custom/camping.js"
import Directions from "./custom/directions.js"

const Icons = {
  Home,
  Cafe,
  Camping,
  Trout,
  Directions,
}

export default Icons
